import { useEffect, useState } from 'react'
import { loadGoogleAnalytics } from './analytics'

export const COOKIE_CONSENT_KEY = 'ea-cookie-consent'

/**
 * Shared localStorage-backed consent state, used by both CookieConsent
 * (renders the banner + Accept/Decline) and ViberBubble (just needs to know
 * whether the banner is currently on screen, so it can shift up out of the
 * way on mobile instead of overlapping it — the banner is full-width/
 * bottom-0, the bubble is fixed bottom-5 right-5, so without this they'd
 * stack on top of each other on a visitor's very first page load).
 *
 * Also owns the actual GA gating: if 'accepted' is already stored (a
 * returning visitor), GA loads on mount. If the visitor clicks Accept in
 * this session, GA loads immediately via dismiss(). Decline never loads it.
 */
export function useCookieConsent() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    try {
      const stored = window.localStorage.getItem(COOKIE_CONSENT_KEY)
      if (!stored) {
        setVisible(true)
      } else if (stored === 'accepted') {
        loadGoogleAnalytics()
      }
    } catch {
      // localStorage unavailable — just skip the banner rather than crash.
    }
  }, [])

  function dismiss(choice: 'accepted' | 'declined') {
    try {
      window.localStorage.setItem(COOKIE_CONSENT_KEY, choice)
    } catch {
      // ignore — worst case the banner reappears next visit
    }
    if (choice === 'accepted') loadGoogleAnalytics()
    setVisible(false)
  }

  return { visible, dismiss }
}
